module.exports = require("@openworklabs/filecoin-wallet-provider");